import {
    FetchRequestType,
    FetchResponseType,
} from "@utilities/types";

// EN: Defines an async function to perform HTTP requests.
export const fetchRequest = async ({
    baseURL = process.env.REACT_APP_BASE_URL,
    route,
    method,
    accessToken,
    data,
    isFormData,
}: FetchRequestType): Promise<FetchResponseType> => {

    const headers: Record<string, string> = {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),
        'ngrok-skip-browser-warning': '1', // pour le tunnel ngrok
    };

    try {
        const response = await fetch(`${baseURL}${route}`, {
            method,
            headers,
            body: data ? (isFormData ? data : JSON.stringify(data)) : undefined,
        });

        const contentType = response.headers.get('content-type');
        const hasJson = contentType && contentType.includes('application/json');
        const responseData = hasJson ? await response.json() : null;

        return {
            code: response.status,
            data: response.ok
                ? responseData
                : responseData?.message || response.statusText || 'Unknown error',
        };

    } catch (error: any) {
        return {
            code: 500,
            data: error.message || 'An unexpected error occurred',
        };
    }
};
